import * as R from 'ramda'

import { getLanguages } from 'utils/languages'
import { getFields } from './tabs/Competencies/model'
import { getModulesOrder } from './tabs/Modules/model'

const modulesOrder = getModulesOrder()

export const mapInternalStateToPayload = state => {
  const {
    absence,
    category,
    competencies,
    description,
    languages,
    modules,
    position,
    productivity,
    template,
    turnover,
    positions,
    department,
    members_with_access,
  } = state

  let turnoverVal = 0.5
  let productivityVal = 0.5
  let absenceVal = 0.5

  if (turnover) {
    // low tornover
    absenceVal = 0.6
    productivityVal = 0.6
    turnoverVal = 0.3
  } else if (productivity) {
    // high productivity
    absenceVal = 0.4
    productivityVal = 0.7
    turnoverVal = 0.4
  } else if (absence) {
    // low absence
    absenceVal = 0.3
    productivityVal = 0.6
    turnoverVal = 0.6
  }

  const payload = {
    category: R.prop('value', category),
    department: department.value,
    description,
    ...(positions && { positions }),
    interview_template: !R.isNil(template) ? R.prop('value', template) : null,
    languages: R.map(({ value }) => value, languages),
    modules: R.reduce(
      (acc, { name, ...rest }) => ({
        ...acc,
        [name === 'ability' ? 'gma' : name]: R.prop(name)(rest),
      }),
      {},
      modules,
    ),
    name: position,
    profile: {
      categories: R.reduce(
        (acc, { name, ...rest }) => ({ ...acc, [name]: R.prop(name)(rest) }),
        {},
        competencies,
      ),
      outputVariables: {
        productivity: productivityVal,
        sicknessAbsence: absenceVal,
        turnover: turnoverVal,
      },
    },
    ...(members_with_access && { members_with_access }),
  }

  return payload
}

export const mapTemplateToInternalState = state => {
  const {
    category,
    description = '',
    interview_template,
    languages = [],
    modules = {},
    name = '',
    positions,
    profile: {
      categories,
      outputVariables: { productivity, sicknessAbsence, turnover } = {},
    } = {},
    department,
    members_with_access,
  } = state ?? {}

  let noPriorityBool = true
  let absenceBool = false
  let productivityBool = false
  let turnoverBool = false

  if (turnover < 0.4) {
    noPriorityBool = false
    turnoverBool = true
  } else if (productivity > 0.6) {
    noPriorityBool = false
    productivityBool = true
  } else if (sicknessAbsence < 0.4) {
    noPriorityBool = false
    absenceBool = true
  }

  const formState = {
    absence: absenceBool,
    category: category ? { label: category, value: category } : null,
    department: { label: department?.name, value: department?.id },
    competencies: !R.isEmpty(categories)
      ? R.pipe(
          R.toPairs,
          R.sort(R.comparator(R.lt)),
          R.map(([name, value]) => ({ [name]: value, name })),
        )(categories)
      : getFields(),
    description,
    languages: R.equals(R.length(languages), 0)
      ? getLanguages()
      : R.map(key => R.find(R.propEq('value', key), getLanguages()), languages),
    modules: R.pipe(
      R.toPairs,
      R.sort(
        ([current], [next]) =>
          R.indexOf(current, modulesOrder) - R.indexOf(next, modulesOrder),
      ),
      R.map(([key, value]) => {
        const name = key === 'gma' ? 'ability' : key

        return { [name]: value, name }
      }),
    )(modules),
    position: name,
    ...(positions && { positions }),
    productivity: productivityBool,
    ...(R.and(interview_template, R.prop('interview', modules)) && {
      template: {
        label: interview_template,
        value: interview_template,
      },
    }),
    ...(members_with_access && {
      members_with_access: members_with_access?.map(member => member.id),
    }),
    turnover: turnoverBool,
    noPriority: noPriorityBool,
  }

  return formState
}
